import React from 'react';

function Header({ usuario, empresa, onVoltar, onSair }) {
  return (
    <header className="w-full flex items-center justify-between bg-blue-700 text-white px-4 py-3 shadow-md">
      {/* Lado esquerdo */}
      <div className="font-bold text-xl tracking-wide">mPm+</div>
      {/* Centro (vazio para espaçamento) */}
      <div className="flex-1"></div>
      {/* Lado direito */}
      <div className="flex items-center space-x-4">
        <span className="text-sm font-semibold">
          {usuario && (
            <>
              Usuário: <span className="font-mono">{usuario.usr_codigo}-{usuario.usr_nome}</span>
            </>
          )}
          {usuario && empresa && ' | '}
          {empresa && (
            <>
              Empresa: <span className="font-mono">{empresa.id}-{empresa.fantasia}</span>
            </>
          )}
        </span>
        {onVoltar && (
          <button
            onClick={onVoltar}
            className="border border-white text-white font-bold py-1 px-3 rounded transition bg-transparent hover:bg-white hover:text-blue-700"
          >
            Voltar
          </button>
        )}
        {onSair && (
          <button
            onClick={onSair}
            className="border border-white text-white font-bold py-1 px-3 rounded transition bg-transparent hover:bg-white hover:text-red-600"
          >
            Sair
          </button>
        )}
      </div>
    </header>
  );
}

export default Header; 